






















import Vue from 'vue';
// scrolling="no"

interface DataType {
  loading: boolean;
  reseting: boolean;
  ifHeight: string | null;
}
export default Vue.extend({
  name: 'GPreview',
  props: {
    value: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: '100%',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  data(): DataType {
    return {
      loading: true,
      ifHeight: null,
      reseting: true,
      // height: '100%',
    };
  },
  methods: {
    reload() {
      if (this.value) {
        this.loading = true;
        this.reseting = true;
        this.$nextTick(() => {
          this.reseting = false;
          this.$nextTick(() => {
            const preview = this.$refs.preview as any;
            preview.contentDocument.write(this.value);
            this.loading = false;
          });
        });
      }
    },
  },
  watch: {
    value(): void {
      this.reload();
    },
  },
  async mounted() {
    this.reload();
  },
});
